import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import { LanguageProvider } from './i18n/LanguageContext';
import AboutPage from './pages/AboutPage';
import DeleteAccountPage from './pages/DeleteAccountPage';
import DemoPage from './pages/DemoPage';
import FeaturesPage from './pages/FeaturesPage';
import HomePage from './pages/HomePage';
import PlusPage from './pages/PlusPage';
import PricingPage from './pages/PricingPage';
import PrivacyPage from './pages/PrivacyPage';
import './styles/site.css';

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="features" element={<FeaturesPage />} />
            <Route path="plus" element={<PlusPage />} />
            <Route path="pricing" element={<PricingPage />} />
            <Route path="about" element={<AboutPage />} />
            <Route path="demo" element={<DemoPage />} />
            <Route path="contact" element={<Navigate to="/demo" replace />} />
            <Route path="privacy-policy" element={<PrivacyPage />} />
            <Route path="delete-account" element={<DeleteAccountPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
